import React from 'react';

const VisionCard = ({ title, description }) => (
  <div className="p-6 shadow-lg bg-white/90 backdrop-blur-sm rounded-2xl">
    <h3 className="mb-4 text-2xl font-semibold text-gray-900">{title}</h3>
    <p className="leading-relaxed text-gray-600">{description}</p>
  </div>
);

const Vision = () => {
  const visionCards = [
    {
      title: "Transparency",
      description: "At SimFinance, we believe that financial decisions should be made with complete clarity and understanding. We are committed to providing clear, honest, and comprehensive information about all financial products on our platform."
    },
    {
      title: "Accessibility",
      description: "We are dedicated to democratizing access to financial services across Ghana, breaking down traditional barriers that have limited financial inclusion"
    },
    {
      title: "Security",
      description: "Protecting your personal and financial information is our paramount concern. We implement rigorous security measures across our platform to ensure your data remains safe"
    },
    {
      title: "Innovation",
      description: "The financial landscape is constantly evolving, and SimFinance is committed to staying at the forefront of financial technology in Ghana."
    },
    {
      title: "Education",
      description: "Financial literacy is the foundation of sound financial decisions. SimFinance is committed to empowering consumers through comprehensive financial education"
    }
  ];

  return (
    <div className="relative py-20 overflow-hidden bg-gradient-to-r from-orange-500/80 via-purple-800 to-purple-900">
      <div className="px-6 mx-auto max-w-7xl lg:px-8">
        {/* Main Vision Text */}
        <div className="max-w-3xl mb-16">
          <h2 className="mb-6 text-4xl font-bold text-white">Our Vision</h2>
          <p className="text-xl leading-relaxed text-white/90">
            A Ghana where everyone has equal access to financial tools and
            information that empower economic growth and personal prosperity.
          </p>
        </div>

        {/* Vision Cards Grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {/* First Row */}
          <div className="lg:col-span-1">
            <VisionCard {...visionCards[0]} />
          </div>
          <div className="lg:col-span-1">
            <VisionCard {...visionCards[1]} />
          </div>
          <div className="lg:col-span-1">
            <VisionCard {...visionCards[2]} />
          </div>

          {/* Second Row */}
          <div className="lg:col-span-1 md:col-span-1">
            <VisionCard {...visionCards[3]} />
          </div>
          <div className="lg:col-span-2 md:col-span-1">
            <VisionCard {...visionCards[4]} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Vision;
